/*引入Vue框架*/
import Vue from 'vue';
/*引入资源请求插件*/
import axios from 'axios';

import {
    baseUrl
} from '../../static/config.js'
/*使用axios插件*/
axios.defaults.baseURL = baseUrl; //本地环境
axios.defaults.timeout =  60000;   //1ms还没有收到请求答复，就超时报错
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// 添加请求拦截器
axios.interceptors.request.use(function(config) {
	// 在发送请求之前做些什么
	/*console.log('开始请求')
	console.log(config);*/
//	config.url = axios.defaults.baseURLbaseURL + config.url ;
	//config.params.canshu = "asdf";   //增加一个公共的参数
	return config;
}, function(error) {
	// 对请求错误做些什么
	console.log('请求失败');
	console.log(error);
	return Promise.reject(error);

});

// 响应拦截器

axios.interceptors.response.use(

	function(response) {　　
		// console.log("响应拦截器response");
		// console.log(response);
		if(response.status === 200 ) return response;
	},
	function(err) {　　
		//请求的地址不对的时候回进入到这里
		console.log("响应拦截器err");
		console.log(err);
		if(err && err.response) {
			switch(err.response.status) {
				case 400:
					err.message = '请求错误(400)';
					break;
				case 401:
					err.message = '未授权，请重新登录(401)';
					break;
				case 403:
					err.message = '拒绝访问(403)';
					break;
				case 404:
					err.message = '请求出错(404)';
					break;
				case 408:
					err.message = '请求超时(408)';
					break;
				case 500:
					err.message = '服务器错误(500)';
					break;
				case 501:
					err.message = '服务未实现(501)';
					break;
				case 502:
					err.message = '网络错误(502)';
					break;
				case 503:
					err.message = '服务不可用(503)';
					break;
				case 504:
					err.message = '网络超时(504)';
					break;
				case 505:
					err.message = 'HTTP版本不受支持(505)';
					break;
				default:
					err.message = err.response.status;
			}

		} else {
			err.message = '连接服务器失败!'
		}
		return Promise.reject(err);
	});

Vue.prototype.$http = axios;
export default({});



// WEBPACK FOOTER //
// ./src/axios/index.js